import { Modal, Button, Input, Select, Switch } from "antd";
import { useState } from "react";

interface ModalAddProps {
    open: boolean;
    onClose: () => void;
}

export function ModalAdd({ open, onClose }: ModalAddProps) {
    const [active, setActive] = useState(true);
    return (
        <Modal
            open={open}
            onCancel={onClose}
            title='Tạo mới tài khoản'
            footer={[
                <div className="flex gap-5 justify-end" style={{ flexWrap: 'wrap' }}>
                    <Button
                        className="px-5 py-2.5 dark:text-white font-medium rounded-md text-xs transition-colors"
                        style={{ background: 'transparent' }}
                    >
                        HỦY BỎ
                    </Button>
                    <Button
                        type="primary"
                        className="px-5 py-2.5 text-white font-medium rounded-md text-xs transition-colors"
                    >
                        CẬP NHẬT
                    </Button>


                </div>
            ]}
        >
            <div className="space-y-5 pt-5">
                {/* Kho */}
                <div className="relative">
                    <label className="absolute -top-2 left-3 z-10 px-1 bg-white dark:bg-gray-900 text-xs text-gray-400">
                        Tên tài khoản <span className="text-red-500">*</span>
                    </label>

                    <Input
                        defaultValue='Ngân hàng ACB'
                        placeholder="Tên tài khoản"
                        className="w-full h-10"
                        size="large"
                    />
                </div>

                <div className="flex items-center gap-3">
                    <Switch
                        checked={active}
                        onChange={setActive}
                        className="scale-60"
                        style={{
                            backgroundColor: active ? "#9fd2e3" : "#d1d5db",
                        }}
                    />

                    <span
                        className={`text-sm ${active ? "text-[#82c2d7]" : "text-gray-500"
                            }`}
                    >
                        {active ? "Hoạt động" : "Không hoạt động"}
                    </span>
                </div>

                <div className="relative">
                    <label className="absolute -top-2 left-3 z-10 px-1 bg-white dark:bg-gray-900 text-xs text-gray-400">
                        Loại tài khoản <span className="text-red-500">*</span>
                    </label>

                    <Select
                        placeholder="Loại tài khoản"
                        defaultValue='1'
                        className="w-full h-10"
                        size="large"
                        options={[
                            { value: '1', label: 'Ngân hàng' }
                        ]}
                    />
                </div>



                {/* Từ ngày - Đến ngày */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div className="relative">
                        <label className="absolute -top-2 left-3 z-10 px-1 bg-white dark:bg-gray-900 text-xs text-gray-400">
                            Ngân hàng <span className="text-red-500">*</span>
                        </label>

                        <Select
                            placeholder="Ngân hàng"
                            defaultValue='1'
                            className="w-full h-10"
                            size="large"
                            options={[
                                { value: '1', label: 'DAF (Ngân hàng Đông Á)' }
                            ]}
                        />
                    </div>

                    <div className="relative">
                        <label className="absolute -top-2 left-3 z-10 px-1 bg-white dark:bg-gray-900 text-xs text-gray-400">
                            Số tài khoản <span className="text-red-500">*</span>
                        </label>

                        <Input
                            defaultValue='34343434'
                            placeholder=" Số tài khoản"
                            className="w-full h-10"
                            size="large"
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}